<template>
  <div class="page-content" style="margin: 0px; width: 100%">
<!--    <PageHeader></PageHeader>-->
    <InfoField></InfoField>
    <Main
        v-if="$route.name === names.MAIN"
        :name_list='left_menu_list'
    ></Main>
    <router-view v-else></router-view>
  </div>
</template>

<script>

import names from "@/modules/guard/routers/names"
import Main from "./Main";
import {getInstMenu, getInstNameByRouterName} from "@/helper/instances";
import PageHeader from "../menus/PageHeader";
import InfoField from "@/modules/guard/orders/components/InfoField";
import {mapGetters} from "vuex";
import admin from "@/urls/roles/admin";
import viewer from "@/urls/roles/viewer";
import entitled from "@/urls/roles/entitled";
import representative from "@/urls/roles/representative";
import responsible from "@/urls/roles/responsible";
import guard from "@/urls/roles/guard";

export default {
  name: "RepresentativeBase",
  // eslint-disable-next-line vue/no-reserved-component-names
  components: {Main, PageHeader, InfoField},
  data(){
    return {
      left_menu_list: [
        // {title: 'Главная', icon: 'home', included: false, router: {name:  names.MAIN, params:{}}},
        {title: "Заявки", icon: "grading", included: true, router: {name:  names.ORDERS.LIST, params:{}}}

      ]
    }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      isAuthenticated: "user/isAuthenticate",
      isMobileView: "isMobileView"
    })
  },
  methods: {
    loadLeftmenu() {
      this.$store.commit("mainpage/changeTitle", "Охрана");
      if (this.isAuthenticated) {
        this.$store.commit("leftmenu/replaceInstances", getInstMenu());
        this.$store.commit("leftmenu/selectInstance", getInstNameByRouterName(names.ORDERS.LIST));
        this.$store.commit("leftmenu/replaceItems", this.getLeftMenu());
      } else {
        this.$store.commit("leftmenu/dissable");
      }
    },
    getLeftMenu() {
      let menu = []
      for (let el in this.left_menu_list){
        menu.push(this.left_menu_list[el])
      }
      return menu
    },
    checkAuthenticate(finalizer=()=>{}){
      if(this.isAuthenticated){
        let is_admin = admin.ADMIN.ALLOWED()
        let is_viewer = viewer.VIEWER.ALLOWED()
        let is_entitled = entitled.ENTITLED.ALLOWED()
        let is_representative = representative.REPRESENTATIVE.ALLOWED()
        // let is_responsible = responsible.RESPONSIBLE.ALLOWED()
        let is_guard = guard.GUARD.ALLOWED()
        if(is_admin || is_viewer || is_entitled || is_representative || is_guard){
          finalizer()
        }
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.checkAuthenticate(
      ()=>{
        this.loadLeftmenu()
      }
    )
    next()
  },
  created() {
    this.checkAuthenticate(
      ()=>{
        this.$store.commit("leftmenu/enableLeftMenu");
        if (!this.isMobileView) this.$store.commit("leftmenu/showLeftMenu");
        this.loadLeftmenu()
      }
    )
  }
}
</script>

<style scoped>

</style>
